import { App, Button, Spin, Tooltip } from 'antd';
import { groupBy } from 'lodash';
import { Box } from '@mui/material';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useEffect, useMemo, useState } from 'react';
import { TableStatusMap } from 'pages/globals/global';
import DataTable from 'components/LynDataTable/DataTable';
import controls from 'assets/images/icons/deactivated.svg';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import deleteIcon from 'assets/images/table-icons/delete_red.svg';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useBulkActivationProcessPositionMutation, useBulkDeleteProcessPositionMutation } from 'store/features/process/processApi';

const ListViewProcessPosition = ({ processRoleMasterList = [], setReloadTable, existingProcessNameMap, isLoading }) => {
	const { message: messageApi } = App.useApp();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [value, setValue] = useState(null);
	const [modalData, setModalData] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [rowSelection, setRowSelection] = useState({});
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const [BulkDeleteProcessPositionHandle, { data: bulkDeleteProcessPositionRes }] = useBulkDeleteProcessPositionMutation();
	const [BulkActiveProcessPositionHandle, { data: bulkActiveProcessPositionRes }] = useBulkActivationProcessPositionMutation();

	const activeDeactiveHandle = (moduleStatus) => {
		let arr = [];

		if (moduleStatus === 'Active') {
			setValue('deactivated');

			setModalData({
				head: 'Process Role',
				label:
					rowSelection?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> this process role?
						</p>
					),
			});

			if (selectedRowKeys[moduleStatus]) {
				selectedRowKeys[moduleStatus]?.forEach((item) => {
					arr.push(item?.id);
				});
			}
		} else if (moduleStatus === 'Inactive') {
			setValue('activated');

			setModalData({
				head: 'Process Role',
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>activate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>activate</b> this this process role?
						</p>
					),
			});

			if (selectedRowKeys[moduleStatus]) {
				selectedRowKeys[moduleStatus]?.forEach((item) => {
					arr.push(item?.id);
				});
			}

			if (selectedRowKeys['W-I-P']) {
				selectedRowKeys['W-I-P']?.forEach((item) => {
					arr.push(item?.id);
				});
			}
		}

		if (arr?.length !== rowSelection?.length) {
			messageApi.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};

	const deleteHandle = (data) => {
		setValue('delete');

		setModalData({
			head: 'Process Role',
			label:
				data?.length > 1 ? (
					<p>
						Do you want to <b style={{ fontSize: '1rem' }}>delete</b> all process role?
					</p>
				) : (
					<p>
						Do you want to <b style={{ fontSize: '1rem' }}>delete</b> this process role?
					</p>
				),
		});

		setSubmitData(data);
		setShowModal(true);
	};

	const handleActionSubmit = () => {
		if (submitData) {
			if (value === 'activated' || value === 'deactivated') {
				BulkActiveProcessPositionHandle({
					activationStatus: value === 'activated' ? 'Active' : 'Inactive',
					data: submitData,
				});
			} else if (value === 'delete') {
				let arr = [];

				submitData?.forEach((item) => {
					arr.push(item?.id);
				});

				BulkDeleteProcessPositionHandle({ data: arr });
			}
		}
	};

	useEffect(() => {
		if (rowSelection?.length) {
			let arr = [];

			rowSelection?.forEach((item) => {
				arr.push(item.original);
			});

			setSelectedRowKeys(groupBy(arr, ({ activationStatus }) => activationStatus));
		}
	}, [rowSelection]);

	useEffect(() => {
		if (bulkActiveProcessPositionRes?.status === 'SUCCESS') {
			let successCount = 0;
			let failedCount = 0;

			bulkActiveProcessPositionRes?.result?.forEach((item) => {
				if (item?.status === 'SUCCESS') {
					successCount++;
				} else if (item?.status === 'FAILED') {
					failedCount++;
				}
			});

			if (successCount > 0) {
				toast.success(`Success! ${successCount} rows ${value}`, toastConfig);
			}

			if (failedCount > 0) {
				toast.error(`Failed! ${failedCount} rows ${value}`, toastConfig);
			}

			setSubmitData(null);
			setValue(null);

			// if (submitData?.length === moduleList?.length) {
			//   setSelectedTab(0);
			// }

			setReloadTable((val) => !val);
		} else if (bulkActiveProcessPositionRes?.status === 'FAILED') {
			toast.error('Process role Status updation Error!', toastConfig);
			setValue(null);
		}
		//eslint-disable-next-line
	}, [bulkActiveProcessPositionRes]);

	useEffect(() => {
		if (bulkDeleteProcessPositionRes?.status === 'SUCCESS') {
			let successCount = 0;
			let failedCount = 0;

			bulkDeleteProcessPositionRes?.result?.forEach((item) => {
				if (item?.status === 'SUCCESS') {
					successCount++;
				} else if (item?.status === 'FAILED') {
					failedCount++;
				}
			});

			if (successCount > 0) {
				toast.success(`Success! ${successCount} rows delete`, toastConfig);
			}

			if (failedCount > 0) {
				toast.error(`Failed! ${failedCount} rows delete`, toastConfig);
			}

			setSubmitData(null);
			setValue(null);

			// if (submitData?.length === moduleList?.length) {
			//   setSelectedTab(0);
			// }

			setReloadTable((val) => !val);
		} else if (bulkDeleteProcessPositionRes?.status === 'FAILED') {
			toast.error('Process role status updation error!', toastConfig);
			setValue(null);
		}
		//eslint-disable-next-line
	}, [bulkDeleteProcessPositionRes]);

	const processPositionMap = {
		USER: 'Fixed Assignment by Practice',
		POSITION: 'Fixed Assignment by Process',
	};

	const activeInactiveStatus = (status) => {
		if (status === 'Active') {
			return (
				<Box style={{ backgroundColor: '#DBF7E2', color: '#30653D', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		} else if (status === 'Inactive') {
			return (
				<Box style={{ backgroundColor: '#FFE2E2', color: '#BB2222', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		} else if (status === 'W-I-P') {
			return (
				<Box style={{ backgroundColor: '#FDF7C4', color: '#694500', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		}
	};

	const COLUMNS = useMemo(
		() => [
			{
				id: 'Selection',
				align: 'center',
				onClicked: true,
				cellAlign: 'center',
				Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
				Header: ({ getToggleAllRowsSelectedProps }) => (
					<IndeterminateCheckbox sx={{ color: 'white', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
				),
			},
			{
				accessor: 'positionCode',
				Header: 'Process Role Name',
			},
			{
				Header: 'By Position/Person',
				accessor: (data) => {
					return processPositionMap[data?.assignType];
				},
			},
			{
				accessor: 'assignValue',
				Header: 'Position/Employee ID',
			},
			{
				Header: 'Position/Employee Name',
				accessor: (data) => (data?.assignType === 'USER' ? data?.assignment?.entityFullName : data?.assignment?.positionName),
			},
			{
				align: 'center',
				Header: 'Status',
				cellAlign: 'center',
				accessor: (data) => {
					return TableStatusMap[data?.activationStatus];
				},
				Cell: (cell) => {
					return activeInactiveStatus(TableStatusMap[cell.row.original.activationStatus]);
				},
			},
			{
				align: 'center',
				Header: 'Action',
				disableSortBy: 'true',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<Tooltip title="View">
							<Button type="text" icon={<img src={viewIcon} width={16} height={16} alt="view" />}></Button>
						</Tooltip>

						<Tooltip title="Edit">
							<Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/static/process-role/edit', {
										state: { roleMasterDetails: cell.row.original, existingProcessNameMap, tab: searchParams.get('tab') },
									});
								}}
							></Button>
						</Tooltip>

						<Tooltip title="Delete">
							<Button
								type="text"
								icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
								onClick={(e) => {
									e.stopPropagation();
									deleteHandle([cell.row.original]);
								}}
							></Button>
						</Tooltip>
					</div>
				),
			},
		], //eslint-disable-next-line
		[existingProcessNameMap]
	);

	return (
		<Spin spinning={isLoading}>
			<DataTable
				COLUMNS={COLUMNS}
				xlsxFileName="entity"
				rowSelection={rowSelection}
				deleteHandle={deleteHandle}
				DATA={processRoleMasterList}
				setRowSelection={setRowSelection}
				activeDeactiveHandle={activeDeactiveHandle}
				onClickHandler={(row) => {
					navigate('/static/process-role/details', {
						state: { roleMasterDetails: row, existingProcessNameMap, tab: searchParams.get('tab') },
					});
				}}
			/>

			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} modalData={modalData} handleSubmit={handleActionSubmit} />
			)}
		</Spin>
	);
};

export default ListViewProcessPosition;